import React, { useState, useEffect } from 'react';
import pb from '../lib/pocketbase';
import { Calendar, ArrowRight, X } from 'lucide-react';
import './NewsSection.css';

const NewsSection = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedNews, setSelectedNews] = useState(null);

    const openModal = (item) => {
        setSelectedNews(item);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setSelectedNews(null);
        document.body.style.overflow = 'auto';
    };

    useEffect(() => {
        const fetchNews = async () => {
            try {
                // Fetch active news only, sorted by date (newest first)
                // Limit to 3 items for the homepage
                const records = await pb.collection('actualites').getList(1, 3, {
                    sort: '-date',
                    filter: 'actif = true'
                });

                const mappedNews = records.items.map(record => ({
                    id: record.id,
                    title: record.titre,
                    content: record.contenu,
                    date: new Date(record.date),
                    image: record.image ? pb.files.getURL(record, record.image) : null
                }));

                setNews(mappedNews);
            } catch (err) {
                if (!err.isAbort) {
                    console.error("Error fetching news:", err);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchNews();
    }, []);

    // Don't render section if no news
    if (!loading && news.length === 0) return null;

    return (
        <section className="news-section">
            <div className="container">
                <div className="text-center animate-fade-in">
                    <h2 className="section-title">Actualités & Événements</h2>
                    <div className="divider" style={{ margin: '20px auto' }}></div>
                    <p style={{ maxWidth: '600px', margin: '0 auto 50px', color: '#666' }}>
                        Restez informés des dernières créations, des événements spéciaux et de la vie de la pâtisserie.
                    </p>
                </div>

                <div className="news-grid">
                    {news.map((item, index) => (
                        <div key={item.id} className="news-card animate-fade-in" style={{ animationDelay: `${index * 0.2}s`, cursor: 'pointer' }} onClick={() => openModal(item)}>
                            {item.image && (
                                <img src={item.image} alt={item.title} className="news-image" />
                            )}
                            <div className="news-content">
                                <div className="news-date">
                                    <Calendar size={14} style={{ marginRight: '5px', verticalAlign: 'text-top' }} />
                                    {item.date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
                                </div>
                                <h3 className="news-title">{item.title}</h3>
                                <div className="news-excerpt">
                                    {item.content.replace(/<[^>]*>?/gm, '').substring(0, 120)}...
                                </div>
                                {/* Future: Link to a full news detail page if needed */}
                                {/* <a href={`/actualites/${item.id}`} className="news-link">Lire la suite <ArrowRight size={16} /></a> */}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {selectedNews && (
                <div className="cake-modal-overlay" onClick={closeModal} style={{ zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="cake-modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '800px', width: '90%', maxHeight: '90vh', overflowY: 'auto' }}>
                        <button className="cake-modal-close" onClick={closeModal} style={{ zIndex: 10 }}>
                            <X size={24} />
                        </button>
                        <div className="cake-modal-split" style={{ display: 'block', padding: 0 }}>
                            {selectedNews.image && (
                                <div style={{ width: '100%', maxHeight: '400px', overflow: 'hidden' }}>
                                    <img src={selectedNews.image} alt={selectedNews.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                </div>
                            )}
                            <div style={{ padding: '40px' }}>
                                <div className="news-date" style={{ marginBottom: '15px', color: 'var(--color-gold)', fontWeight: 'bold' }}>
                                    <Calendar size={14} style={{ marginRight: '5px', verticalAlign: 'text-top' }} />
                                    {selectedNews.date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
                                </div>
                                <h2 style={{ fontFamily: 'var(--font-heading-small)', fontSize: '2.2rem', color: 'var(--color-brown)', marginBottom: '20px' }}>{selectedNews.title}</h2>
                                <div className="news-full-content" style={{ color: '#444', lineHeight: '1.8', fontSize: '1.05rem', marginTop: '20px' }} dangerouslySetInnerHTML={{ __html: selectedNews.content }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default NewsSection;
